// Breadcrumbs.js
import React from 'react';
import { Link, useLocation, useParams } from 'react-router-dom';
import { Breadcrumbs as MuiBreadcrumbs, Typography } from '@mui/material';

const Breadcrumb = () => {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter((x) => x);
  const { cohortId, quizId, evaluationId, courseId, masterId } = useParams();

  const breadcrumbItems = [
    { name: 'Home', path: '/' },
    ...(masterId ? [{ name: 'MasterSolution', path: '/masterSolution' }] : []),
    ...(quizId && !pathnames.includes("performanceDashboard") ? [{ name: `Quizzes`, path: `/cohort/${cohortId}/quizzes` }] : []),
    ...(evaluationId && !pathnames.includes("performanceDashboard") ? [{ name: `Evaluations`, path: `/cohort/${cohortId}/quiz/${quizId}/evaluations` }] : []),
    // ...(pathnames.includes('listOfQuizzes') ? [{ name: 'PerformanceDashboard', path: '/performanceDashboard' }] : []),
    // ...(pathnames.includes('listOfQuizzes/cohort') ? [{ name: 'listOfQuizzes', path: '/performanceDashboard/listOfQuizzes' }] : []),
    ...(pathnames.includes("listOfQuizzes")
      ? [{ name: "performanceDashboard", path: "/performanceDashboard" }]
      : []),

    ...(courseId && quizId && pathnames.includes("listOfQuizzes")
      ? [
        {
          name: "listOfQuizzes",
          path: `/performanceDashboard/listOfQuizzes`,
        },
      ]
      : []),
    ...(evaluationId && pathnames.includes("performanceDashboard") ? [{ name: `Evaluations`, path: `/performanceDashboard/listOfQuizzes/cohort/${courseId}/quiz/${quizId}/evaluations` }] : []),

  ];


  return (
    <MuiBreadcrumbs aria-label="breadcrumb">
      {breadcrumbItems.map((item, index) => (
        <Link key={index} to={item.path}>
          {item.name}
        </Link>
      ))}
      <Typography color="text.primary" textTransform={"capitalize"}>{pathnames[pathnames.length - 1]}</Typography>
    </MuiBreadcrumbs>
  );
};

export default Breadcrumb;
